import { render, staticRenderFns } from "./OvertimeDetail.vue?vue&type=template&id=f25d55fa&scoped=true"
import script from "./OvertimeDetail.vue?vue&type=script&lang=js"
export * from "./OvertimeDetail.vue?vue&type=script&lang=js"
import style0 from "./OvertimeDetail.vue?vue&type=style&index=0&id=f25d55fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25d55fa",
  null
  
)

export default component.exports